import { quickEntries, stats } from "@/mocks/scandal";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200/70 bg-background-50">
      <div className="absolute inset-0 bg-paper-grid opacity-60" />
      <div className="pointer-events-none absolute -right-40 -top-40 h-96 w-96 rounded-full bg-primary-100/70 blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl" />

      <div className="relative mx-auto max-w-6xl px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-8">
          {/* 左：文案 + 入口 */}
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
              <span className="text-xs font-bold text-primary-700">抖音黑料 · 吃瓜时间线档案库</span>
            </div>

            <h2 className="font-heading mt-5 text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
              把抖音黑料的
              <span className="text-primary-600">来龙去脉</span>
              <br />
              一次从头看到尾
            </h2>

            <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
              不想再自己翻聊天记录、蹲评论区拼瓜？这里把抖音黑料的前因后果按时间线重新捋一遍——从刚开始发酵到当事人回应，
              全记录、发展经过、关键节点都按顺序放好，照着读就完事。
            </p>

            {/* 入口条压顶 */}
            <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {quickEntries.map((e) => (
                <a
                  key={e.to}
                  href={e.to}
                  className="group flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm font-semibold text-foreground-800 whitespace-nowrap transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
                >
                  <i className={`${e.icon} text-primary-500`} />
                  {e.label}
                </a>
              ))}
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-shield-check-line text-accent-600" /> 结构整理 · 出处可溯
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-refresh-line text-primary-500" /> 节点持续维护
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-bookmark-line text-secondary-600" /> 支持收藏归档
              </span>
            </div>
          </div>

          {/* 右：主视觉 */}
          <div className="lg:col-span-5">
            <div className="relative mx-auto max-w-md">
              <div className="overflow-hidden rounded-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20phone%20screen%20showing%20breaking%20news%20notification%20and%20live%20updates%2C%20surrounded%20by%20magnifying%20glass%2C%20chat%20bubble%20and%20timeline%20icons%2C%20crimson%20red%20and%20warm%20amber%20accents%20on%20cream%20paper%20background%2C%20minimalist%20magazine%20style%2C%20soft%20shadows%2C%20clean%20and%20layered%20composition&width=900&height=1000&seq=heiliao-hero-2026&orientation=portrait"
                  alt="抖音黑料 吃瓜时间线整理示意图"
                  title="抖音黑料 吃瓜时间线整理示意图"
                  className="h-72 w-full object-cover object-top md:h-[400px]"
                />
              </div>
              <div className="absolute -bottom-3 left-3 rounded-lg border border-background-200 bg-background-50/95 px-3 py-2 shadow-sm">
                <div className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-500 animate-pulse-dot" />
                  <span className="text-xs font-bold text-foreground-800 whitespace-nowrap">主线节点 · 今日已更 3 处</span>
                </div>
              </div>
              <div className="absolute -top-3 right-3 rounded-lg border border-accent-200 bg-accent-50/95 px-3 py-2 shadow-sm">
                <div className="flex items-center gap-2">
                  <i className="ri-timer-line text-accent-600" />
                  <span className="text-xs font-bold text-accent-800 whitespace-nowrap">全程 12 章脉络</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 速览统计条 */}
        <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-background-200 bg-background-200 sm:grid-cols-5">
          {stats.map((s) => (
            <div key={s.label} className="bg-background-50 px-4 py-5 text-center">
              <div className="flex items-baseline justify-center gap-1">
                <span className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{s.value}</span>
                {s.unit && <span className="text-xs font-medium text-foreground-500">{s.unit}</span>}
              </div>
              <div className="mt-1 text-xs text-foreground-500">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}